import { type AxiosPromise } from "axios";
import React from "react";
import RelatedFiles from "../../../components/RelatedFiles/RelatedFiles";
import { type FileTypes } from "shared/utils/fileutils";

interface Props {
  onFilesSelected: (files: server.dto.File[]) => void
  fetchRelatedFiles: () => AxiosPromise<server.dto.ApiResponseWrapper<server.dto.RelatedFiles>>
  fileSizeLimit: number
  validFileTypes: FileTypes
}

const FromStorage = (props: Props) => {
  const [relatedFiles, setRelatedFiles] = React.useState<server.dto.RelatedFiles>(undefined);
  const [selectedFiles, setSelectedFiles] = React.useState<server.dto.File[]>([]);

  React.useEffect(() => {
    props.fetchRelatedFiles().then(res => {
      setRelatedFiles(res.data.data);
    });
  }, []);

  return <RelatedFiles
    onFilesSelected={props.onFilesSelected}
    selectedFiles={selectedFiles}
    onSelectedFilesChanged={setSelectedFiles}
    relatedFiles={relatedFiles}
    maxFileSize={props.fileSizeLimit}
    validFileTypes={props.validFileTypes}
  />;
};

export default FromStorage;